class CreativeVariable {
    constructor(creativeVariableResponse, parameters) {
        this.id = parameters.id;
        this.context = parameters.context;
        Object.assign(this, creativeVariableResponse);
    }
}
CreativeVariable.DEFAULT_LOCALE = "en";
export default CreativeVariable;
